<template>
	<nav id="sidebar" class="sidebar" aria-label="Main navigation">
		<a class="sidebar-brand" data-cy="dashboard-link">
			<span class="sr-only">Go to dashboard</span>
			<img src="@/assets/img/logo.png" alt="Clarus Care logo" />
		</a>
		<div class="sidebar-item-container">
			<ul
				:class="[
					'sidebar-items',
					{ 'sidebar-items-engage': isEngageApp && !clarusAppType },
				]"
			>
				<li v-if="clarusAppType" class="sidebar-item">
					<router-link
						class="sidebar-link"
						aria-current="page"
						role="link"
						data-cy="calls-link"
						data-tooltip="Calls"
						data-position="right"
						:to="{
							name: 'app.calls',
						}"
					>
						<font-awesome-icon :icon="['fal', 'phone-volume']" />
						<span class="sr-only">Calls</span>
					</router-link>
				</li>

				<li v-if="clarusAppType" class="sidebar-item">
					<router-link
						class="sidebar-link"
						data-cy="scheduling-link"
						data-tooltip="Scheduling"
						data-position="right"
						:to="{
							name: 'app.schedules',
						}"
					>
						<font-awesome-icon
							size="2x"
							:icon="['fal', 'calendar']"
						/>
						<span class="sr-only">Scheduling</span>
					</router-link>
				</li>
				<li
					v-if="hasOfficeManagerAccess && clarusAppType"
					class="sidebar-item"
				>
					<router-link
						class="sidebar-link"
						data-cy="providers-link"
						data-tooltip="Providers"
						data-position="right"
						:to="{
							name: 'app.providers',
						}"
					>
						<font-awesome-icon :icon="['fal', 'user-md']" />
						<span class="sr-only">Providers</span>
					</router-link>
				</li>
				<li
					v-if="hasOfficeManagerAccess && clarusAppType"
					class="sidebar-item"
				>
					<router-link
						exact-path
						class="sidebar-link"
						data-cy="insights-link"
						aria-current="insights"
						data-tooltip="Insights"
						data-position="right"
						:to="{
							name: 'app.dashboard',
						}"
					>
						<font-awesome-icon :icon="['fal', 'analytics']" />
						<span class="sr-only">Insights</span>
					</router-link>
				</li>
				<li v-if="isEngageApp" class="sidebar-item">
					<router-link
						href="#"
						class="sidebar-link"
						data-cy="engage-link"
						data-tooltip="Engage"
						data-position="right"
						:to="{
							name: 'app.engage',
						}"
					>
						<EngageIcon />
						<span class="sr-only">Engage</span>
					</router-link>
				</li>
				<li
					v-if="
						(hasOfficeManagerAccess && clarusAppType) ||
							isOrgAdmin ||
							isOrganizationOnlyAdmin
					"
					class="sidebar-item"
				>
					<router-link
						href="#"
						class="sidebar-link"
						data-cy="settings-link"
						data-tooltip="Settings"
						data-position="right"
						:to="settingsRoute"
					>
						<font-awesome-icon :icon="['fal', 'cog']" />
						<span class="sr-only">Settings</span>
					</router-link>
				</li>
				<li class="app-version">Version {{ appVersion }}</li>
			</ul>
		</div>
	</nav>
</template>
<script>
import { mapGetters } from 'vuex'
import { version } from '../../package.json'
import EngageIcon from './Icons/EngageIcon.vue'

export default {
	components: {
		EngageIcon,
	},
	/**
	 * The component's computed properties.
	 *
	 * @type {Object}
	 */
	computed: {
		settingsRoute() {
			if (this.isOrganizationOnlyAdmin && this.organizationId) {
				return {
					name: 'app.organization',
					params: { organizationId: this.organizationId },
				}
			}

			return { name: 'app.settings' }
		},

		...mapGetters('auth', [
			'hasOfficeManagerAccess',
			'haslimitedManagerAccess',
			'isOrgAdmin',
			'isOrganizationOnlyAdmin',
			'organizationId',
		]),
		...mapGetters('partners', [
			'hasPagingEnabled',
			'clarusAppType',
			'isEngageApp',
		]),
	},

	/**
	 * The component's name used for debugging.
	 *
	 * @type {String}
	 */
	name: 'Sidebar',

	/**
	 * The component's before destroy lifecycle hook.
	 *
	 * @return {void}
	 */
	beforeDestroy() {
		this.addedToChannelListener?.unsubscribe()
		this.newMessageListener?.unsubscribe()
		this.notificationReadListener?.unsubscribe()
	},

	/**
	 * Get the component's initial state.
	 *
	 * @return {Object}
	 */
	data() {
		return {
			addedToChannelListener: null,
			newMessageListener: null,
			appVersion: version,
			notificationReadListener: null,
		}
	},
}
</script>
